export default __webpack_public_path__ + "static/media/product-arrow1.d9320eba.svg";